/* Élan Vivre — Modern Minimal behaviours: product trust list, sticky add-to-cart, cart drawer note. */
(function () {
  var ICON = {
    truck: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/></svg>',
    cod: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="6" width="18" height="12" rx="2"/><circle cx="12" cy="12" r="2.4"/></svg>',
    clock: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
    shield: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l8 3v6c0 4.5-3.2 7.6-8 9-4.8-1.4-8-4.5-8-9V6z"/><path d="M8.5 12l2.5 2.5 4.5-5"/></svg>'
  };

  function onProduct() { return /\/products\//.test(location.pathname); }

  function addTrust() {
    if (!onProduct() || document.querySelector('.ev-trust')) return;
    var form = document.querySelector('product-form') || document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var ul = document.createElement('ul');
    ul.className = 'ev-trust';
    ul.innerHTML =
      '<li>' + ICON.truck + 'Free shipping across India</li>' +
      '<li>' + ICON.cod + 'Cash on Delivery available</li>' +
      '<li>' + ICON.clock + 'Ships in 24h · Delivered in 3–5 days</li>' +
      '<li>' + ICON.shield + 'Dermatologically tested</li>';
    form.parentNode.insertBefore(ul, form.nextSibling);
  }

  function stickyAtc() {
    if (!onProduct() || document.querySelector('.ev-sticky-atc')) return;
    var btn = document.querySelector('product-form button[name="add"], form[action*="/cart/add"] button[name="add"]');
    if (!btn || !('IntersectionObserver' in window)) return;
    var title = (document.querySelector('.product__title') || {}).textContent || document.title;
    var bar = document.createElement('div');
    bar.className = 'ev-sticky-atc';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Quick add to cart');
    var t = document.createElement('div');
    t.className = 'ev-sticky-atc__t';
    var name = document.createElement('span');
    name.textContent = title.trim();
    var price = document.createElement('span');
    price.className = 'ev-sticky-atc__p';
    t.appendChild(name);
    t.appendChild(price);
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ev-sticky-atc__b';
    b.addEventListener('click', function () { btn.click(); });
    bar.appendChild(t);
    bar.appendChild(b);
    document.body.appendChild(bar);

    function sync() {
      var p = document.querySelector('.product .price-item--sale, .product .price-item--last, .price .price-item--regular');
      price.textContent = p ? p.textContent.trim() : '';
      var label = btn.querySelector('span');
      b.textContent = (label ? label.textContent : btn.textContent).trim() || 'Add to cart';
      b.disabled = btn.disabled;
      b.style.opacity = btn.disabled ? '.5' : '';
    }
    sync();
    new MutationObserver(sync).observe(document.querySelector('main') || document.body, { childList: true, subtree: true, characterData: true });
    new IntersectionObserver(function (e) {
      var visible = e[0].isIntersecting;
      var above = e[0].boundingClientRect.top < 0;
      bar.classList.toggle('is-on', !visible && above);
    }).observe(btn);
  }

  function cartNote() {
    var foot = document.querySelector('.cart-drawer__footer, cart-drawer .drawer__footer');
    if (!foot || foot.querySelector('.ev-cart-note')) return;
    var n = document.createElement('p');
    n.className = 'ev-cart-note';
    n.textContent = 'Free shipping across India · Cash on Delivery available';
    foot.appendChild(n);
  }

  function run() { addTrust(); stickyAtc(); cartNote(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { addTrust(); cartNote(); }, 150); }).observe(document.documentElement, { childList: true, subtree: true });
})();
